import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import Container, { Row, Third, Half, TwoThird, Full } from "../layout/container"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Sidemenu from "../layout/sidebar";
import VisitingSidemenu from "../layout/sidebar-visiting";
import TraderMapItems from "../blog/trader-map-items"
import Arches from "./arches";
import Shops from "./shops";
import Stalls from "./stalls";

const Section = styled.section`
  background: ${(props) => props.theme.colors.white};
  padding: 3rem 0 3rem;
  h2 {
    //font-family: ${(props) => props.theme.fontBold};
    position: relative;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  .react-tabs {
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      margin-top: 2rem;
    }
  }

  .react-tabs__tab-list {
      border-bottom: 2px solid ${props => props.theme.colors.secondary};
      .react-tabs__tab {
          border: none;
          color: ${props => props.theme.colors.secondary};
            padding: 0 2rem 0.5rem 0;
            @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
              padding: 0 1rem 0.5rem 0;
            }
      }
      .react-tabs__tab--selected {
            background: none;
            color: ${props => props.theme.colors.primary};
            border-radius: 0;
      }
  }

`;

const ContainerRowChange = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    flex-direction: column;
  }
`



const Button = styled(Link)`
    font-size: 1rem;
    padding: 1rem 0;
    text-align: center;
    margin: 1rem 0;
    border: 2px solid #00FFB4;
    color: #3C3C3B;
    -webkit-text-decoration: none;
    text-decoration: none;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    z-index: 3;
    position: relative;
    width: 100%;
  &:hover {
    background: transparent;
    border: 2px solid ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.5rem 2rem;
    font-size: 1.5rem;
  }
`

const ImageBlock = styled.div`
  padding: 2rem 0;
`

const Credit = styled.div`
  padding-left: 1rem;
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding-left: 0;
    padding-top: 1rem;
  }
  p {
    font-size: 0.6rem;
    padding-bottom: 0.2rem;
    margin: 0;
  }
`

const Banner = styled.div`
    .alert {
        display: flex;
        background-color: #EED0C7;
        justify-content: space-between;
        &.hide {
            display-none;
        }
        p {
            padding: 0.5rem 0 0.5rem 1rem;
            margin: 0;
        }
        span {
            padding: 0.5rem 1rem 0.5rem 0;
        }
    }
  
`

  const AddressBlock = styled.ul`
        font-family: ${(props) => props.theme.fontCondensed};
        margin: 0;
        display: inline-block;
        padding: 0;
        li {
          :first-child {
            font-size: 0.6rem;
            padding-bottom: 0.5rem;
          }
          list-style: none;
        }
  `






const MarketMap = () => {
    const data = useStaticQuery(graphql`{

        file(relativePath: {eq: "Replacement_map.png"}) {
            childImageSharp {
            gatsbyImageData(width: 743, layout: CONSTRAINED)
            }
        }
        }
    `)
    
  return (
    <Section id="market-map">
            <h2>
              MARKET MAP
            </h2>
            <ContainerRowChange>
                <Half>
                    <GatsbyImage image={data.file.childImageSharp.gatsbyImageData} />
                </Half>
                <Half>
                    <Tabs>
                        <TabList>
                            <Tab>Arches</Tab>
                            <Tab>Shops</Tab>
                            <Tab>Stalls</Tab>
                        </TabList>

                        <TabPanel>
                            <Row>
                                <Arches />
                            </Row>
                        </TabPanel>
                        <TabPanel>
                            <Row>
                                <Shops />
                            </Row>
                        </TabPanel>
                        <TabPanel>
                            <Row>
                                <Stalls />
                            </Row>
                        </TabPanel>
                    </Tabs>
                </Half>
            </ContainerRowChange>
    </Section>
  );
};

export default MarketMap;

